/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Package_EditInputs */

const vi_tea_package_edit = /** @type {(inputs: Tea_Package_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa gói chè`)
};

/**

* @param {Tea_Package_EditInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_package_edit = /** @type {((inputs?: Tea_Package_EditInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Package_EditInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_package_edit(inputs)
});